import { Injectable } from '@angular/core';
import { IUser } from '../interfaces';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private USER_KEY = 'tabUser';

  constructor() {}

  getUser(): IUser | null {
    const user: string | null = localStorage.getItem(this.USER_KEY);

    if (!user) {
      return null;
    }

    return JSON.parse(user) as IUser;
  }

  setUser(user: IUser): void {
    const _user = JSON.stringify(user);

    if (_user === undefined) {
      localStorage.removeItem(this.USER_KEY);
    } else {
      localStorage.setItem(this.USER_KEY, _user);
    }
  }

  removeUser(): void {
    localStorage.removeItem(this.USER_KEY);
  }
}
